class ClientSideSwatches extends HTMLElement {
  static get observedAttributes () {
    return ['data-related-products']
  }

  constructor () {
    super()

    this.state = {
      relatedProducts: []
    }
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'data-related-products' && newValue !== '') {
      this.relatedProducts = JSON.parse(newValue)
    }
  }

  async fetchRelatedProductData (productHandle) {
    const endpoint = `https://${window.Shopify.shop}/api/2025-07/graphql.json`
    const accessToken = window.theme.nostoMerchandisingAccessToken

    const graphqlQuery = `
        query GetProduct($handle: String!) {
          product(handle: $handle) {
            title,
            id,
            priceRange {
              minVariantPrice {
                amount
              },
              maxVariantPrice {
                amount
              }
            },
            compareAtPriceRange {
              minVariantPrice {
                amount
              },
              maxVariantPrice {
                amount
              }
            },
            images(first: 2) {
              nodes {
                url
              }
            }
          }
        }
      `

    try {
      const variables = { handle: productHandle }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken
        },
        body: JSON.stringify({ query: graphqlQuery, variables })
      })

      if (!response.ok) throw new Error('Failed to fetch product data')
      const data = await response.json()

      return data.product || {}
    } catch (error) {
      console.error('Error fetching extra data:', error)
      return {} // Return empty object as fallback
    }
  }

  get relatedProducts () {
    return this.state.relatedProducts
  }

  set relatedProducts (relatedProducts) {
    const splitRelatedProducts = relatedProducts.split('|')

    this.state.relatedProducts = splitRelatedProducts

    splitRelatedProducts.forEach(product => {
      this.fetchRelatedProductData(product)
    })
  }
}

customElements.define('client-side-swatches', ClientSideSwatches)
